export default __webpack_public_path__ + "static/media/linkedin.d5041fd4.svg";